module.exports = __webpack_public_path__ + "static/media/knife.b3c03bbc.svg";